/** This is a auto-generated file, please do not modify it */
import { GlobalStore, initContext, Modifiers } from '@talpor/react-context-manager';

import { authStore, IAuthStore } from './auth/store';
import { authActions, IAuthActions } from './auth/actions';
import { dashboardStore, IDashboardStore } from './dashboard/store';
import { dashboardActions, IDashboardActions } from './dashboard/actions';
import { dataStore, IDataStore } from './data/store';
import { dataActions, IDataActions } from './data/actions';
import { diagnosticsStore, IDiagnosticsStore } from './diagnostics/store';
import { diagnosticsActions, IDiagnosticsActions } from './diagnostics/actions';
import { membersStore, IMembersStore } from './members/store';
import { membersActions, IMembersActions } from './members/actions';
import { miscStore, IMiscStore } from './misc/store';
import { miscActions, IMiscActions } from './misc/actions';
import { resourcesStore, IResourcesStore } from './resources/store';
import { resourcesActions, IResourcesActions } from './resources/actions';
import { surveysStore, ISurveysStore } from './surveys/store';
import { surveysActions, ISurveysActions } from './surveys/actions';
import { teamsStore, ITeamsStore } from './teams/store';
import { teamsActions, ITeamsActions } from './teams/actions';
import { tenantsStore, ITenantsStore } from './tenants/store';
import { tenantsActions, ITenantsActions } from './tenants/actions';

export interface IStore extends GlobalStore {
  auth: IAuthStore;
  dashboard: IDashboardStore;
  data: IDataStore;
  diagnostics: IDiagnosticsStore;
  members: IMembersStore;
  resources: IResourcesStore;
  surveys: ISurveysStore;
  misc: IMiscStore;
  teams: ITeamsStore;
  tenants: ITenantsStore;
}

export interface IActions extends Modifiers<IStore> {
  auth: IAuthActions;
  dashboard: IDashboardActions;
  data: IDataActions;
  diagnostics: IDiagnosticsActions;
  members: IMembersActions;
  misc: IMiscActions;
  resources: IResourcesActions;
  surveys: ISurveysActions;
  teams: ITeamsActions;
  tenants: ITenantsActions;
}

const store: IStore = {
  auth: authStore,
  dashboard: dashboardStore,
  data: dataStore,
  diagnostics: diagnosticsStore,
  members: membersStore,
  misc: miscStore,
  resources: resourcesStore,
  surveys: surveysStore,
  teams: teamsStore,
  tenants: tenantsStore,
};

const actions: IActions = {
  auth: authActions,
  dashboard: dashboardActions,
  data: dataActions,
  diagnostics: diagnosticsActions,
  members: membersActions,
  misc: miscActions,
  resources: resourcesActions,
  surveys: surveysActions,
  teams: teamsActions,
  tenants: tenantsActions,
};

const ctx = initContext<IStore, IActions>();

export { actions, ctx, store };
